import { ErrorManager } from './ErrorManager';

/**
 *
 * @param {{ priority: number }} [options={}]
 * @return {import('vue/types/options').ComponentOptions}
 */
export const useErrorInfoSubscriber = (options= {}) => ({
    static: {
        errorTypes: ErrorManager.ErrorInfoType,
        disposals: []
    },
    created() {
        this.disposals = [...(this.disposals ?? []), ErrorManager.instance.subscribe(this._handleErrorInfo, options)];
    },
    beforeDestroy() {
        this.disposals.forEach((dispose) => dispose());
    },
    methods: {
        _handleErrorInfo(errorInfo) {
            this.onError(errorInfo);
        },
        onError(errorInfo) {
            console.error(errorInfo);
        }
    }
});
